import { takeLatest, put, select } from 'redux-saga/effects';
import { getDefaultStore } from 'jotai';
import { message } from 'antd';
import getMetricsData from '@api/metricContainer';
import { autoRequest } from '@api/createRequestStore';

import * as actions from './actions';
import * as types from './types';
import * as selectors from './selectors';
import * as baseTypes from '../base/types';
import { get } from 'lodash';
import { checkIfSampledCluster } from '@components/common/SampledDataWarning';
import { handleServerError } from '@utils/errors/serverError';
import { processAnnotations } from '@src/components/common/DataAnnotations';
import { getCurrentKpiConfig } from '@src/hooks/useCurrentKpiConfig';

function* initRequest() {
  yield put(actions.init());
}

function* fetching() {
  let payload = yield select(selectors.payloadSelector);
  if (!payload || payload.length < 1) {
    return;
  }
  const store = getDefaultStore();
  const currentKpiConfig = getCurrentKpiConfig(store);
  payload = payload.map((body) => {
    const q0 = body.queries?.[0];
    if (!q0?.options) return body;
    return {
      ...body,
      queries: [
        { ...q0, options: { ...q0.options, kpiConfig: currentKpiConfig ?? {} } },
        ...(body.queries?.slice(1) ?? []),
      ],
    };
  });
  try {
    yield put(actions.fetching());
    yield autoRequest(getMetricsData, types.SCOPE, payload, (response) => {
      const annotations = get(response, [0, 0, 'annotations'], []);

      // TODO: move annotation parsing to common util - processAnnotations
      checkIfSampledCluster(annotations);
      processAnnotations(annotations);
    });
  } catch (error) {
    handleServerError(error);
  }
}

function* removeRangeData({ index }) {
  yield put(actions.removeRangeData(index));
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchFetching() {
  yield takeLatest(
    [
      types.FETCH_DATA,
      baseTypes.SET_SELECTED_DIMENSION,
      baseTypes.SET_SELECTED_METRICS,
      baseTypes.SET_SELECTED_FILTERS,
      baseTypes.SET_SELECTED_INTERVAL,
      baseTypes.SET_DEFAULT_FILTER_INTERVAL,
      baseTypes.SET_APPLIED_SORT,
      types.REMOVE_RANGE_DATA,
      baseTypes.REMOVE_APPLIED_FILTER,
    ],
    fetching,
  );
}

function* watchFilterRemove() {
  yield takeLatest([baseTypes.REMOVE_APPLIED_FILTER], removeRangeData);
}

export default [watchInitRequest, watchFetching, watchFilterRemove];
